import { type Locale } from "./routing";
import { matchSupportedTag } from "./resolve-signup-locale";

/**
 * 브라우저가 알려주는 읽기 언어를 지원 locale 로 변환한다.
 * 서버 Accept-Language 파싱(resolveSignupLocale)과 동일한 매칭 규칙을 쓰도록
 * matchSupportedTag 를 공유한다(zh-Hans/zh-Hant/zh-HK/zh-MO 포함).
 *
 * 무매치 시 "en" 이 아니라 null 을 돌려주는 것이 ClientLocaleRedirect 와의 차이다.
 * 저쪽은 "어디로든 보내야 하는" 리다이렉트라 en 폴백이 필요하지만, 여기는
 * "다른 언어로 볼래요?" 제안이 목적이라 근거 없는 제안(en 강권)을 하면 안 된다.
 */
export function detectBrowserLocale(): Locale | null {
  if (typeof navigator === "undefined") return null;

  const candidates = [navigator.language, ...(navigator.languages ?? [])];

  for (const tag of candidates) {
    if (!tag) continue;
    const matched = matchSupportedTag(tag);
    if (matched) return matched satisfies Locale;
  }

  return null;
}
